import getStoreProperty from "components/ProjectNonSpecificComponents/DevTools/Functions/getStoreProperty"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { useOuterClick } from "components/ProjectNonSpecificComponents/Hooks/useOuterClick"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import useSearchParam from "components/ProjectSpecificComponents/Functions/useSearchParam"
import { IFormsConfig } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { observer } from "mobx-react-lite"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import MediumButton from "../../Global/atoms/Buttons/MediumButton"

const UserSideActiveConfigNavigation = observer(() => {
	const { t } = useTranslation()
	const formStore = useFormStore()
	const store = useStore()
	const { userSelectedForm } = formStore
	const location = useLocation()
	const [activeConfigurations, setActiveConfiguration] = useState<IFormsConfig[]>([])
	let type = useSearchParam("form")

	const componentRef = useOuterClick(() => {
		setConfigListOpen(false)
	})

	// Collect active configs
	useEffect(() => {
		const getActiveConfigurations = async () => {
			const activeConfigs = formStore.settingsData.formsConfigs.filter(({ isActive }) => isActive)
			if (activeConfigs.length > 0) {
				let config = !type ? activeConfigs[0] : activeConfigs.find(({ nameURL }) => nameURL == type)
				formStore.setUserSelectedForm(config ?? activeConfigs[0])
			} else {
				formStore.setUserSelectedForm(undefined)
			}

			setActiveConfiguration(activeConfigs)
		}

		getActiveConfigurations()
	}, [formStore.settingsData.formsConfigs, location.pathname, type])

	const [configListOpen, setConfigListOpen] = useState<boolean>(false)

	return (
		<HyperDiv height="100%" centered ref={componentRef as any}>
			{activeConfigurations?.length > 0 && (
				<MediumButton
					iconKey={"arrow-down-rounded"}
					iconHeight="0.75rem"
					iconWidth="0.75rem"
					iconAndTextColor={formStore.settingsData.personalize.colorHeaderText}
					iconSide="right"
					style={{
						color: formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)",
						background: "none",
						fontSize: 14,
					}}
					borderless
					onClick={() => setConfigListOpen((isOpen) => !isOpen)}
					children={
						userSelectedForm?.name
							? `${t("user-request.change-type")} : ${userSelectedForm.name.toUpperCase()} `
							: ""
					}
				/>
			)}

			{configListOpen && activeConfigurations?.length > 0 && (
				<ConfigDropdown>
					{activeConfigurations.map((form) => {
						const { id, name } = form
						return (
							<ConfigOption
								className="hide-overflown-text-nowrap"
								key={id}
								onClick={() => {
									formStore.setUserSelectedForm(form)

									setConfigListOpen((isOpen) => !isOpen)
								}}
							>
								{name}
							</ConfigOption>
						)
					})}
				</ConfigDropdown>
			)}
		</HyperDiv>
	)
})

export default UserSideActiveConfigNavigation

const ConfigDropdown = styled.div`
	position: fixed;
	z-index: 30;
	transform: translate(-00%, 65%);
	background-color: white;
	border: 1px solid var(--light-gray);
	padding: 2px 0px;
	border-radius: 5px;
`

const ConfigOption = styled.div`
	color: #333333;
	font-size: small;
	padding: 10px;
	padding-right: 10px;
	border-radius: 2px;
	cursor: pointer;
	width: 200px;

	:hover {
		background-color: var(--light-light-blue);
	}
`
